// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "transactionGroup.proto" (package "transaction", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TransactionGroupService } from "./transactionGroup";
import type { DeleteTransactionGroupResponse } from "./transactionGroup";
import type { DeleteTransactionGroupRequest } from "./transactionGroup";
import type { SetGroupedTransactionSplitResponse } from "./transactionGroup";
import type { SetGroupedTransactionSplitRequest } from "./transactionGroup";
import type { ChangeTransactionGroupSplitResponse } from "./transactionGroup";
import type { ChangeTransactionGroupSplitRequest } from "./transactionGroup";
import type { UpdateTransactionGroupResponse } from "./transactionGroup";
import type { UpdateTransactionGroupRequest } from "./transactionGroup";
import type { CreateTransactionGroupResponse } from "./transactionGroup";
import type { CreateTransactionGroupRequest } from "./transactionGroup";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllTransactionGroupsResponse } from "./transactionGroup";
import type { GetAllTransactionGroupsRequest } from "./transactionGroup";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service transaction.TransactionGroupService
 */
export interface ITransactionGroupServiceClient {
    /**
     * @generated from protobuf rpc: GetAllTransactionGroups
     */
    getAllTransactionGroups(input: GetAllTransactionGroupsRequest, options?: RpcOptions): UnaryCall<GetAllTransactionGroupsRequest, GetAllTransactionGroupsResponse>;
    /**
     * @generated from protobuf rpc: CreateTransactionGroup
     */
    createTransactionGroup(input: CreateTransactionGroupRequest, options?: RpcOptions): UnaryCall<CreateTransactionGroupRequest, CreateTransactionGroupResponse>;
    /**
     * @generated from protobuf rpc: UpdateTransactionGroup
     */
    updateTransactionGroup(input: UpdateTransactionGroupRequest, options?: RpcOptions): UnaryCall<UpdateTransactionGroupRequest, UpdateTransactionGroupResponse>;
    /**
     * @generated from protobuf rpc: ChangeTransactionGroupSplit
     */
    changeTransactionGroupSplit(input: ChangeTransactionGroupSplitRequest, options?: RpcOptions): UnaryCall<ChangeTransactionGroupSplitRequest, ChangeTransactionGroupSplitResponse>;
    /**
     * @generated from protobuf rpc: SetGroupedTransactionSplit
     */
    setGroupedTransactionSplit(input: SetGroupedTransactionSplitRequest, options?: RpcOptions): UnaryCall<SetGroupedTransactionSplitRequest, SetGroupedTransactionSplitResponse>;
    /**
     * @generated from protobuf rpc: DeleteTransactionGroup
     */
    deleteTransactionGroup(input: DeleteTransactionGroupRequest, options?: RpcOptions): UnaryCall<DeleteTransactionGroupRequest, DeleteTransactionGroupResponse>;
}
/**
 * @generated from protobuf service transaction.TransactionGroupService
 */
export class TransactionGroupServiceClient implements ITransactionGroupServiceClient, ServiceInfo {
    typeName = TransactionGroupService.typeName;
    methods = TransactionGroupService.methods;
    options = TransactionGroupService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllTransactionGroups
     */
    getAllTransactionGroups(input: GetAllTransactionGroupsRequest, options?: RpcOptions): UnaryCall<GetAllTransactionGroupsRequest, GetAllTransactionGroupsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllTransactionGroupsRequest, GetAllTransactionGroupsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateTransactionGroup
     */
    createTransactionGroup(input: CreateTransactionGroupRequest, options?: RpcOptions): UnaryCall<CreateTransactionGroupRequest, CreateTransactionGroupResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateTransactionGroupRequest, CreateTransactionGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateTransactionGroup
     */
    updateTransactionGroup(input: UpdateTransactionGroupRequest, options?: RpcOptions): UnaryCall<UpdateTransactionGroupRequest, UpdateTransactionGroupResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateTransactionGroupRequest, UpdateTransactionGroupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ChangeTransactionGroupSplit
     */
    changeTransactionGroupSplit(input: ChangeTransactionGroupSplitRequest, options?: RpcOptions): UnaryCall<ChangeTransactionGroupSplitRequest, ChangeTransactionGroupSplitResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ChangeTransactionGroupSplitRequest, ChangeTransactionGroupSplitResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetGroupedTransactionSplit
     */
    setGroupedTransactionSplit(input: SetGroupedTransactionSplitRequest, options?: RpcOptions): UnaryCall<SetGroupedTransactionSplitRequest, SetGroupedTransactionSplitResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetGroupedTransactionSplitRequest, SetGroupedTransactionSplitResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteTransactionGroup
     */
    deleteTransactionGroup(input: DeleteTransactionGroupRequest, options?: RpcOptions): UnaryCall<DeleteTransactionGroupRequest, DeleteTransactionGroupResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteTransactionGroupRequest, DeleteTransactionGroupResponse>("unary", this._transport, method, opt, input);
    }
}
